import React, { MouseEvent, useCallback } from 'react';
import { AppCustomIcons } from '../../utils/custom-icons';
import { AppSvgIcon } from '../svg-icon/app-svg-icon';
import './app-button-icon.scss';

export interface AppButtonIconProps {
  id?: string;
  icon: AppCustomIcons;
  onClick?: (e: MouseEvent<HTMLDivElement> | React.KeyboardEvent<HTMLDivElement>, id?: string) => void;
  label?: string;
  className?: string;
  labelClassName?: string;
  iconClassName?: string;
}

export const AppButtonIcon = (props: AppButtonIconProps) => {
  const handleClick = useCallback(
    (e: MouseEvent<HTMLDivElement>) => {
      e.preventDefault();
      if (props.onClick) props.onClick(e, props.id);
    },
    [props]
  );

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        props.onClick?.(e, props.id);
      }
    },
    [props]
  );

  return (
    <div id={props.id} className={`app-button-icon ${props.className ?? ''}`} onClick={handleClick} onKeyDown={handleKeyDown} tabIndex={0}>
      <AppSvgIcon icon={props.icon} className={`app-button-icon-svg ${props.iconClassName ?? ''}`} />
      {props.label && (
        <label htmlFor={props.id} className={`app-button-icon-label ${props.labelClassName ?? ''}`}>
          {props.label}
        </label>
      )}
    </div>
  );
};
